module.exports = __webpack_public_path__ + "a561f1a2a02a9310add2a4da0322f112.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/black_eradicated.png
 ** module id = 995
 ** module chunks = 0
 **/